import React from 'react';
import useBreadcrumbs from "use-react-router-breadcrumbs";
import {Link} from "react-router-dom";

export function Breadcrumbs() {
    const breadcrumbs = useBreadcrumbs();

    return (
        <React.Fragment>
        <div style={{position: "absolute", top:35, left:35, zIndex: 10, fontSize: "16px"}}>
            {breadcrumbs.map(( breadcrumb, index ) => {
                if(index === 0) return;
                return <span  key={index}>
                    <Link key={breadcrumb.key} to={breadcrumb.key} style={{ color: "rgb(113, 182, 249)"}}>{breadcrumb.breadcrumb?.props?.children}</Link>
                    <span>{" / "}</span>
                </span>;
            })}
            </div>
        </React.Fragment>
    );
}